import React from "react";
import {
  Box,
  Card,
  CardContent,
  Skeleton,
} from "@mui/material";

const PortfolioSummarySkeleton: React.FC = () => {
  return (
    <Card
      elevation={0}
      sx={{
        background: (theme) =>
          theme.palette.mode === "dark"
            ? "rgba(35, 35, 35, 0.8)"
            : "rgba(255, 255, 255, 0.9)",
        // REMOVED for performance: backdropFilter: "blur(20px)",
        border: (theme) =>
          theme.palette.mode === "dark"
            ? "1px solid rgba(255, 255, 255, 0.08)"
            : "1px solid rgba(0, 0, 0, 0.06)",
        borderRadius: 4,
        boxShadow: (theme) =>
          theme.palette.mode === "dark"
            ? "0 4px 30px rgba(0, 0, 0, 0.3)"
            : "0 4px 30px rgba(0, 0, 0, 0.08)",
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ p: 0 }}>
        {/* Primary Metrics Section */}
        <Box sx={{ p: 4, pb: 1 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-start", md: "flex-end" },
              justifyContent: "space-between",
              gap: { xs: 3, md: 4 },
            }}
          >
            {/* Total Portfolio Value - Hero Element */}
            <Box sx={{ flex: 1 }}>
              {/* Label */}
              <Skeleton 
                variant="text" 
                width={180} 
                height={16} 
                sx={{ mb: 1 }}
              />
              {/* Large Value */}
              <Skeleton 
                variant="text" 
                width={320} 
                height={48} 
                sx={{ 
                  mb: 2,
                  width: { xs: 280, md: 320 },
                  height: { xs: 40, md: 48 }
                }}
              />
              {/* Day Change Indicator */}
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.04)"
                      : "rgba(0, 0, 0, 0.02)",
                }}
              >
                <Skeleton variant="circular" width={6} height={6} />
                <Skeleton variant="text" width={120} height={14} />
                <Skeleton variant="text" width={40} height={14} />
              </Box>
            </Box>

            {/* Total Return - Mirrored Hero Element */}
            <Box sx={{ flex: 1, textAlign: { xs: "left", md: "right" } }}>
              {/* Label */}
              <Skeleton 
                variant="text" 
                width={120} 
                height={16} 
                sx={{ mb: 1, ml: { xs: 0, md: "auto" } }}
              />
              {/* Large Value */}
              <Skeleton 
                variant="text" 
                width={280} 
                height={48} 
                sx={{ 
                  mb: 2, 
                  ml: { xs: 0, md: "auto" },
                  width: { xs: 240, md: 280 },
                  height: { xs: 40, md: 48 }
                }}
              />
              {/* Total Return Percentage Indicator */}
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.04)"
                      : "rgba(0, 0, 0, 0.02)",
                }}
              >
                <Skeleton variant="circular" width={6} height={6} />
                <Skeleton variant="text" width={80} height={14} />
                <Skeleton variant="text" width={60} height={14} />
              </Box>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PortfolioSummarySkeleton;